import { Platform } from 'react-native';

import { apiClient } from '@/services/api';
import type { User } from '@/types/user';

export interface MergeRequestResponse {
  ok: boolean;
  contact_masked: string;
}

/**
 * Login-shaped on purpose: confirming a merge tombstones the CURRENT
 * account server-side, so its Bearer token is dead the moment this
 * resolves — the client must swap to this session in place.
 */
export interface MergeConfirmEnvelope {
  ok: boolean;
  session_token: string;
  expires_at: string;
  user: User;
}

/**
 * Verified-PIN account merge — the campaign completion form's answer to
 * `email_taken`. Both endpoints run on the bare phone account's session;
 * the email is proven by the code the server mails to it.
 */
export const accountMergeService = {
  request(email: string): Promise<MergeRequestResponse> {
    return apiClient.post<MergeRequestResponse>('/api/v1/account_merges', { email });
  },

  confirm(email: string, code: string): Promise<MergeConfirmEnvelope> {
    return apiClient.post<MergeConfirmEnvelope>('/api/v1/account_merges/confirm', {
      email,
      code,
      client: Platform.OS === 'web' ? 'web' : 'ios',
    });
  },
};
